import React from 'react';
import { scoreToBand, BAND_COLORS } from './types';
export function ProgressBar({ score, height = 8 }) {
    return (<div className="w-full rounded-full overflow-hidden bg-gray-100" style={{ height }} role="progressbar" aria-valuenow={score} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full rounded-full" style={{
            width: `${Math.min(100, Math.max(0, score))}%`,
            backgroundColor: BAND_COLORS[scoreToBand(score)],
            transition: 'width 0.6s ease',
        }}/>
        </div>);
}
